import api from './api';

const contractRenewalService = {
  // Get all contract renewals
  getAllContractRenewals: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.renewalType) queryParams.append('renewalType', params.renewalType);
      if (params.originalContractId) queryParams.append('originalContractId', params.originalContractId);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.pendingRenewals) queryParams.append('pendingRenewals', params.pendingRenewals);

      const queryString = queryParams.toString();
      const url = `/contract-renewal${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching contract renewals:', error);
      throw error;
    }
  },

  // Get contract renewal by ID
  getContractRenewalById: async (id) => {
    try {
      const response = await api.get(`/contract-renewal/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching contract renewal:', error);
      throw error;
    }
  },

  // Get next renewal number
  getNextRenewalNumber: async () => {
    try {
      const response = await api.get('/contract-renewal/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next renewal number:', error);
      throw error;
    }
  },

  // Create contract renewal
  createContractRenewal: async (renewalData) => {
    try {
      const response = await api.post('/contract-renewal', renewalData);
      return response.data;
    } catch (error) {
      console.error('Error creating contract renewal:', error);
      throw error;
    }
  },

  // Update contract renewal
  updateContractRenewal: async (id, renewalData) => {
    try {
      const response = await api.put(`/contract-renewal/${id}`, renewalData);
      return response.data;
    } catch (error) {
      console.error('Error updating contract renewal:', error);
      throw error;
    }
  },

  // Delete contract renewal
  deleteContractRenewal: async (id) => {
    try {
      const response = await api.delete(`/contract-renewal/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting contract renewal:', error);
      throw error;
    }
  },

  // Get contract renewal statistics
  getContractRenewalStats: async () => {
    try {
      const response = await api.get('/contract-renewal/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching contract renewal statistics:', error);
      throw error;
    }
  },

  // Approve contract renewal
  approveContractRenewal: async (id, approvalNotes) => {
    try {
      const response = await api.put(`/contract-renewal/${id}/approve`, { approvalNotes });
      return response.data;
    } catch (error) {
      console.error('Error approving contract renewal:', error);
      throw error;
    }
  },

  // Reject contract renewal
  rejectContractRenewal: async (id, rejectionReason) => {
    try {
      const response = await api.put(`/contract-renewal/${id}/reject`, { rejectionReason });
      return response.data;
    } catch (error) {
      console.error('Error rejecting contract renewal:', error);
      throw error;
    }
  }
};

export default contractRenewalService;

